import instance from '../_http'

export default {
  /**
   * 单点登录
   * @param {*} loginData
   * @returns
   */
  loginByCas: (serviceUrl, ticket) => {
    return instance.post('/api/system/loginByCas?serviceUrl=' + serviceUrl + '&ticket=' + ticket)
  }

}
